import { service } from '@ember/service';
import type { ValidatorMap } from 'ember-changeset/types';
import type FlashMessagesService from 'ember-cli-flash/services/flash-messages';
import type { IntlService } from 'ember-intl';
import { modifier } from 'ember-modifier';
import CrudJournalEventBaseComponent from 'parog-web/components/forc/abstract/crud-journal-event-based-component';
import type { ToastMessage } from 'parog-web/components/forc/abstract/journal-event-based-component';
import Provider from 'parog-web/components/forc/provider';
import JournalEventRetrievalStrategies from 'parog-web/components/forc/utils/journal-event-retrieval-strategies';
import HeightMeasuredJournalEvent from 'parog-web/models/height-measured-journal-event';
import type SemeiaSessionService from 'parog-web/services/session';
import formatNumberAsString from 'parog-web/utils/format-number-as-string';

export default class HeightEditionFormComponent extends CrudJournalEventBaseComponent<HeightMeasuredJournalEvent> {
  static override forcDisplayName = 'Mesure de la taille';
  static override fullComponentId = 'measurements/height-edition-form';
  static override journalEventClass = HeightMeasuredJournalEvent;

  @service declare flashMessages: FlashMessagesService;
  @service declare intl: IntlService;
  @service declare session: SemeiaSessionService;

  override journalEventProperties = ['occurredAt', 'height'];
  override retrieveJournalEvent =
    JournalEventRetrievalStrategies.sourceJournalEvent;

  override get toastMessage(): ToastMessage | null {
    return this.session.patient
      ? {
          message: 'Votre mesure a bien été prise en compte.',
          title: 'Taille'
        }
      : super.toastMessage;
  }

  override get validations(): ValidatorMap {
    return this.journalEventClass.validations(this.intl);
  }

  focus = modifier(function (element: HTMLDivElement): void {
    (element.querySelector('.ui.input input') as HTMLInputElement).focus();
  });

  override async save(): Promise<void> {
    this.changeset.set(
      'height',
      formatNumberAsString(this.changeset.get('height'))
    );

    await super.save();
  }

  <template>
    <Provider @forcComponent={{this}}>
      <:content as |Form|>
        <div class='two fields'>
          <div class='field'>
            <Form.Date
              @labelName='Date de la mesure'
              @propertyName='occurredAt'
            />
          </div>
          <div class='field' {{this.focus}}>
            <Form.NumberInput @labelName='Taille (cm)' @propertyName='height' />
          </div>
        </div>
      </:content>
    </Provider>
  </template>
}
